import { observer } from 'mobx-react-lite'
import { Status } from 'shared/ui'
import { type KnowledgeBaseDocumentStatus } from 'entities/KnowledgeBase'
import { getKnowledgeBaseDocumentStatusConfig } from 'widgets/KnowledgeBase/lib/getKnowledgeBaseDocumentStatusConfig'

interface KnowledgeBaseDocumentStatusLabelProps {
  status: KnowledgeBaseDocumentStatus
  className?: string
}

export const KnowledgeBaseDocumentStatusLabel = observer(
  ({ status, className }: KnowledgeBaseDocumentStatusLabelProps) => {
    const config = getKnowledgeBaseDocumentStatusConfig(status)

    if (!config) return null

    return <Status {...config} className={className} />
  }
)
